<template>
  <div class="w-full flex">

    <!-- Preview for form editor -->
    <div v-if="productData == null" class="w-full flex gap-1 items-center">
      <input
          :readonly="true"
          class="outline-0 border border-trader-input-border p-1 w-full my-1 shadow-inner-2"
          :class="{ 'bg-inactive' : true}"
          >
      <input :readonly="formField.readOnly" type="checkbox" class="p-1 w-4 h-4 my-1 " @change="(e) => { e.preventDefault(); e.target.checked = false;}" :value="false">
    </div>

    <!-- Fieldtype -->
    <div v-else class="w-full flex gap-1 items-center">
      <input
          :readonly="true"
          :value="value"
          @input="() => onUpdateFieldValue(formField.field, 'string')"
          class="border border-trader-input-border p-1 w-full my-1 shadow-inner-2"
          :class="{ 'bg-inactive' : true, 'bg-trader-red': productData.customFields[formField.field]?.highlight }"
          :data-ui="'input-'+ formField.label">

      <!--  v-model="productData.customFields[formField.field].value" -->
      <input :disabled="readOnly" type="checkbox" class="p-1 w-4 h-4 my-1 " v-model="active" @change="toggle">
    </div>

  </div>
</template>

<script>
export default {
  props: {
    name: "Price Per Unit",
    formField: {
      type: Object,
      default: {
        readOnly: false,
      }
    },
    productData: {
      type: Object,
      default: () => {
      }
    },
    onChangeProductFieldValue: {
      type: Function,
      default: () => {}
    },
    getFieldValue: {
      type: Function,
      default: () => {
      }
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
    }
  },
  computed: {
    value() {

      const price_per_unit = this.getFieldValue('price_per_unit') || '';
      const price = this.getFieldValue('price') || '';
      const quantity = this.getFieldValue('quantity') || '';

      if (price_per_unit == '' || price == '' || quantity == '') {
        return '';
      }

      return this.getFieldValue(this.formField.field);
    },
    active() {
      const price_per_unit = this.getFieldValue('price_per_unit') || '';
      const price = this.getFieldValue('price') || '';
      const quantity = this.getFieldValue('quantity') || '';

      if (price_per_unit == '' || price == '' || quantity == '') {
        return false;
      }

      return true;

      //return this.getFieldValue(this.formField.field) !== undefined && this.getFieldValue(this.formField.field) !== '';
    }
  },
  methods: {
    calculateUnitPrice(nettoPrice, units) {
      try {
        
        const netto = parseFloat(nettoPrice.replace(',', '.') * 10000);
        const unit = parseFloat(units);
        const unitPrice = Math.round(netto / unit);
        const rounded = Math.round(unitPrice / 10);
        
        const result = '' + (rounded / 1000).toFixed(3);

        //if the third decimal is 0, remove it
        const c = result.split('.');
        if (c.length === 2 && c[1].length === 3 && c[1].charAt(2) === '0') {
          return c[0] + '.' + c[1].charAt(0) + c[1].charAt(1);
        }
        if (result <= 0.0 || isNaN(result)) {
          return "";
        }

        return result;
      } catch (error) {
        return "";
      }
    },
    onUpdateFieldValue(field, type) {
      this.onChangeProductFieldValue(field, type);
    },
    toggle() {
      if (!this.active) {
        const price = this.getFieldValue('price');
        const quantity = this.getFieldValue('quantity');
        let package_type = this.getFieldValue('package_type');

        const bottleTypes = ['MW-Flasche', 'Bügelflasche', 'MW-Bügelflasche','PET-MW-Bügelflasche', 'PET-MW-Flasche', 'PET-EW-Flasche', 'EW-Flasche'];
        for(let i = 0; i < bottleTypes.length; i++) {
          if(package_type.toString() === bottleTypes[i].toString()) {
            package_type = 'Flasche';
          }
        }


        const unitPrice = this.calculateUnitPrice(price, quantity);
        const value = unitPrice !== '' ? unitPrice + ' / ' + package_type : '';

        this.onChangeProductFieldValue(this.formField.field, 'string', value);
      } else {
        this.onChangeProductFieldValue(this.formField.field, 'string', '');
      }
    }
  }
}
</script>


